/**
 * Storage
 */
export default class Storage {

    constructor() {
        this.contacts = {};
    }

    /**
     *
     * @param currentVersion
     * @param latestVersion
     * @returns {number}
     */
    compareVersion = (currentVersion, latestVersion) => {
        if (currentVersion === latestVersion || !currentVersion || !latestVersion) {
            return 0;
        }
        const _currentVersion = currentVersion.split('.');
        const _latestVersion = latestVersion.split('.');

        for (let i = 0; i < _latestVersion.length; i++) {
            if (Number(_latestVersion[i]) > Number(_currentVersion[i])) {
                return 1;
            } else if (Number(_latestVersion[i]) < Number(_currentVersion[i])) {
                return -1;
            }
        }

        return 0;
    };

    /**
     *
     * @param title
     */
    setTitle = title => {
        document.title = `Wildix Conference${title ? ` - ${title}` : ''}`;
    };


    /**
     *
     * @returns {*}
     */
    getRoomToken = () => {
        if (typeof APP?.store?.getState === 'function') {
            return APP.store.getState()['features/base/config'].roomToken;
        }

        return window.config.roomToken || '';
    }

    /**
     *
     */
    setDisconnectInfo(info) {
        localStorage.setItem(`disconnectInfo_${this.getRoomToken()}`, JSON.stringify(info));
    }

    /**
     *
     * @returns {string}
     */
    getDisconnectInfo() {
        return JSON.parse(localStorage.getItem(`disconnectInfo_${this.getRoomToken()}`)) || {};
    }

    /**
     *
     */
    removeDisconnectInfo() {
        localStorage.removeItem(`disconnectInfo_${this.getRoomToken()}`);
    }

    /**
     *
     */
    setHintsSettings(data) {
        localStorage.setItem('hints', JSON.stringify(data));
    }

    /**
     *
     */
    getHintsSettings() {
        return JSON.parse(localStorage.getItem('hints')) || {};
    }
}
